export default function LoginError() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="bg-bt-surface border border-bt-border rounded-lg p-8 max-w-md text-center">
        <h1 className="text-xl font-semibold mb-2">Login failed</h1>
        <p className="text-bt-muted text-sm mb-6">Discord authentication could not be completed. This can happen with an expired or reused login request.</p>
        <a href="/api/auth/discord" className="bg-bt-accent hover:bg-bt-accentHover text-white rounded px-5 py-2 text-sm">Try again</a>
      </div>
    </div>
  );
}
